import React, { Component } from "react";
import TextField                             from "material-ui/TextField";

import "../CSS/style_iconTextLabel.css";

class InputIcon extends Component {

    constructor(props){
        super(props);
    }

    render() {

        return (
            <div style={{display: "flex", flexDirection : "row"}}>
                <span style={{marginTop: "37px", color:"grey!important", marginRight:"7px"}}>{this.props.icon}</span>
                <div className="">
                    <TextField className={this.props.class}
                    onChange          ={this.props.onChange}
                    hintText          ={this.props.hintText}
                    floatingLabelText ={this.props.floatingLabelText}
                    value             ={this.props.value}/>
                </div>
            </div>
        );
    }
}

export default InputIcon;


// WEBPACK FOOTER //
// ./src/Components/component_IconInput.js